import { useState } from "react";
import { saveAs } from "file-saver";
import { buscarArquivoByFileNameService } from "../../../services/buscarArquivoByFileNameService";

export const useBaixarArquivo = (
  fileName: string,
  mimetype: string,
  nomeArquivo: string
) => {
  const [isLoading, setIsLoading] = useState(true);

  const baixarArquivo = async () => {
    try {
      const data = await buscarArquivoByFileNameService(fileName);
      if (data) {
        const blob = new Blob([data], {
          type: mimetype,
        });

        saveAs(blob, nomeArquivo);
      }
    } catch (error) {
      console.error("Erro ao baixar Arquivo:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return { baixarArquivo, isLoading };
};
